<!-- wrapper para fixar na esquerda e "sobrepor" o grid -->
<div *ngIf="showFilterBar && (activeFiltersCount > 0 || videoUrls.length > 0)"
    class="ss-discover-filterbar-wrap" [class.is-col4]="isCol4">
    <div class="ss-discover-filterbar is-expanded" [class.is-expanded]="filterBarExpanded"
        [class.panel-open]="filterPanelOpen" (mouseenter)="onFilterBarMouseEnter()"
        (mouseleave)="onFilterBarMouseLeave()">
        <!-- Botão filtro (formato 1) .ss-g-btns-menu-right-->
        <button pButton type="button" class="m-0 border-none ss-g-btns-menu-right ss-discover-filterbtn"
            (click)="toggleFilterBarExpanded()" style="overflow: visible;">
            <i class="pi pi-filter text-lg"></i>
            <span *ngIf="activeFiltersCount > 0" class="ss-filter-badge"></span>
        </button>

        <!-- Conteúdo horizontal (formato 2) - SEM *ngIf para animar suave -->
        <div class="ss-discover-filter-content">
            <span class="ss-discover-filter-title ml-4">Filtros <span *ngIf="activeFiltersCount > 0">
                    ({{ activeFiltersCount }})
                </span></span>

            <div class="ss-discover-filter-chips">
                <div class="ss-dialog-header-chips">
                    <p-chip *ngFor="let chip of selectedHeaderChips; trackBy: trackChip" [label]="chip.label"
                        [removable]="true" (onRemove)="removeChip(chip)" styleClass="ss-filter-chip"></p-chip>
                </div>
            </div>

            <!-- menu (3 pauzinhos) -->
            <button type="button" class="ss-discover-menu-btn" (click)="$event.stopPropagation(); toggleFilterPanel()">
                <i class="pi pi-bars text-white"></i>
            </button>
        </div>
    </div>
</div>

<!-- Painel vertical (formato 3) - dropdown preso na barra -->
<p-dialog [(visible)]="filterPanelOpen" [modal]="true" [closable]="true" [dismissableMask]="true" [draggable]="false"
    [resizable]="false" [closeOnEscape]="true" [showHeader]="true" styleClass="ss-discover-filterdialog"
    (onHide)="closeFilterPanel()" class="dialog1 ss-dialogDiscover ss-g-dialog-sized">
    <!-- ✅ HEADER custom dentro do header nativo -->
    <ng-template pTemplate="header">
        <div class="ss-dialog-header">
            <div class="ss-dialog-header-left">
                <div class="ss-dialog-filter-icon-wrap">
                    <i class="pi pi-filter ss-dialog-header-icon"></i>

                    <span *ngIf="activeFiltersCount > 0" class="ss-filter-badge ss-filter-badge--dialog"></span>
                </div>
                <span class="ss-dialog-header-title font-bold">
                    Filtros <span *ngIf="activeFiltersCount > 0">
                        ({{ activeFiltersCount }})
                    </span>
                </span>

                <div class="ss-dialog-header-chips">
                    <p-chip *ngFor="let chip of selectedHeaderChips; trackBy: trackChip" [label]="chip.label"
                        [removable]="true" (onRemove)="removeChip(chip)" styleClass="ss-filter-chip"></p-chip>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="ss-discover-filterpanel-body">
        <div class="card mb-0">
            <div class="flex flex-column gap-3 mb-4">
                <label class="w-full ss-g-globalClassLabel text-left">
                    Categorias
                    <div class="mb-2"></div>
                    <ng-container *ngIf="msMount">
                        <p-multiSelect #catMs [options]="categoryOptions" [(ngModel)]="selectedCategories"
                            optionLabel="label" dataKey="value" placeholder="Selecionar categorias" [filter]="true"
                            [showClear]="true" display="chip" class="w-full ss-ms" [appendTo]="isMobile ? 'target' : 'body'"
                            panelStyleClass="ss-discover-ms-panel ss-discover-ms-panel--cat" scrollHeight="100px"
                            (onPanelShow)="onCategoryPanelShow(catMs)" (onChange)="onFiltersChanged()"
                            (onClear)="onMultiClear('cat')" [virtualScroll]="true" [itemSize]="44" [lazy]="true"
                            (onLazyLoad)="onCategoryLazyLoad($event)" (onFilter)="onCategoryFilter($event)">
                            <ng-template pTemplate="item" let-opt>
                                <div class="ss-cat-opt">
                                    <span class="ss-cat-label">{{ opt?.label }}</span>
                                </div>
                            </ng-template>

                            <ng-template pTemplate="footer">
                                <div class="p-2" *ngIf="catLoading">
                                    <p-skeleton width="100%" height="16px" class="mb-2"></p-skeleton>
                                    <p-skeleton width="80%" height="16px" class="mb-2"></p-skeleton>
                                    <p-skeleton width="90%" height="16px"></p-skeleton>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                    </ng-container>
                </label>
            </div>
            <div class="flex flex-column gap-3">
                <label class="w-full ss-g-globalClassLabel text-left">
                    Influenciadores
                    <div class="mb-2"></div>
                    <ng-container *ngIf="msMount">
                        <p-multiSelect #infMs [options]="influencerOptions" [(ngModel)]="selectedInfluencers"
                            optionLabel="label" dataKey="value" placeholder="Selecionar influenciadores" [filter]="true"
                            [showClear]="true" display="chip" class="w-full ss-ms" [appendTo]="isMobile ? 'target' : 'body'"
                            panelStyleClass="ss-discover-ms-panel ss-discover-ms-panel--inf"
                            (onPanelShow)="onInfluencerPanelShow(infMs)" (onChange)="onFiltersChanged()"
                            (onClear)="onMultiClear('inf')" [virtualScroll]="true" [itemSize]="52" [lazy]="true"
                            (onLazyLoad)="onInfluencerLazyLoad($event)" (onFilter)="onInfluencerFilter($event)">
                            <!-- ✅ itens do dropdown (você já tem) -->
                            <ng-template pTemplate="item" let-opt>
                                <div class="ss-inf-opt">
                                    <img class="ss-inf-avatar" [src]="opt?.avatar || 'assets/layout/images/avatar.png'" alt="" />
                                    <span class="ss-inf-handle">{{ opt?.label }}</span>
                                </div>
                            </ng-template>

                            <!-- ✅ como os SELECIONADOS aparecem no input (chips) -->
                            <ng-template pTemplate="selectedItems" let-items>
                                <div class="ss-selected-row" *ngIf="items?.length; else empty">
                                    <div class="ss-selected-chip" *ngFor="let it of items; trackBy: trackInf">
                                        <img class="ss-selected-avatar" [src]="it?.avatar || 'assets/layout/images/avatar.png'" alt="" />
                                        <span class="ss-selected-label">{{ it?.label }}</span>

                                        <!-- opcional: remover individual -->
                                        <button type="button" class="ss-selected-remove"
                                            (click)="removeSelectedInfluencer(it, $event)" aria-label="Remover">
                                            ×
                                        </button>
                                    </div>
                                </div>

                                <ng-template #empty>
                                    <span class="ss-selected-placeholder">Selecionar influenciadores</span>
                                </ng-template>
                            </ng-template>
                        </p-multiSelect>
                    </ng-container>
                </label>
            </div>

        </div>

        <!-- Fechar dialog -->
        <button pButton type="button" label="Fechar" icon="pi pi-times" class="w-full mt-3"
            (click)="filterPanelOpen = false"></button>
        <!-- Limpar fora do panel e 100% -->
        <button pButton type="button" label="Limpar filtros" icon="pi pi-filter-slash"
            class="p-button-outlined w-full mt-0" (click)="clearAllFilters()">
        </button>

    </div>
</p-dialog>


<!-- MOSAIC -->
<div *ngIf="discoverLayout === 'mosaic'" [class.is-col4]="isCol4">

    <div *ngIf="showSkeleton" class="discover-grid mosaic">
        <div class="discover-tile tile-1x2" *ngFor="let s of skeletonItems; trackBy: trackSkel">
            <p-skeleton width="100%" height="100%"></p-skeleton>
        </div>
    </div>

    <ng-container *ngIf="!showSkeleton">
        <div *ngFor="let p of pages; trackBy: trackPage" #pageWrap [attr.data-page-id]="p.id"
            class="discover-page-wrap">
            <div class="discover-grid mosaic">
                <div *ngFor="let v of p.placed; trackBy: trackVideo"
                    class="discover-tile" [ngClass]="v.__cls"
                    (click)="openModal(v)">
                    <img [src]="v.thumbnail" loading="lazy" decoding="async" />
                    <button *ngIf="showPostItemBadge" pButton type="button"
                        class="p-button-rounded p-button-lg p-overlay-badge m-0 border-none ss-g-custom-bg ss-g-btns-menu-sup ss-g-btns-menu-right-grid ss-discover-icon-btn"
                        (click)="$event.stopPropagation(); onOpenSidebar()" style="overflow: visible;">
                        <i [ngClass]="iconMode === 'bag' ? 'bi bi-bag' : 'pi pi-shopping-cart'"
                            style="font-size: 1.2rem;"></i>
                        <span class="ss-discover-badge" *ngIf="(v.products?.length || 0) > 0">
                            {{ v.products?.length || 0 }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>

</div>

<!-- GRID simples -->
<div *ngIf="discoverLayout === 'grid'" class="discover-grid simple">
    <div class="discover-tile tile-1x2" *ngFor="let v of videoUrls; trackBy: trackVideo" (click)="openModal(v)">
        <img [src]="v.thumbnail" loading="lazy" decoding="async" />
        <button *ngIf="showPostItemBadge" pButton type="button"
            class="p-button-rounded p-button-lg p-overlay-badge m-0 border-none ss-g-custom-bg ss-g-btns-menu-sup ss-g-btns-menu-right-grid ss-discover-icon-btn"
            (click)="$event.stopPropagation(); onOpenSidebar()" style="overflow: visible;">
            <i [ngClass]="iconMode === 'bag' ? 'bi bi-bag' : 'pi pi-shopping-cart'"
                style="font-size: 1.2rem;"></i>
            <span class="ss-discover-badge" *ngIf="(v.products?.length || 0) > 0">
                {{ v.products?.length || 0 }}
            </span>
        </button>
    </div>
</div>
<!-- Load more SEMPRE fora -->
<div class="ss-discover-loadmore" *ngIf="hasMoreVideos">
    <button type="button" class="ss-loadmore-btn" (click)="loadMore()" [disabled]="isLoadingSlides || loading"
        aria-label="Carregar mais">
        <ng-container *ngIf="!(isLoadingSlides || loading); else loadingTpl">
            <i class="bi bi-plus-circle ss-loadmore-icon" aria-hidden="true"></i>
        </ng-container>

        <ng-template #loadingTpl>
            <i class="pi pi-spinner ss-loadmore-spinner" aria-hidden="true"></i>
        </ng-template>
    </button>
</div>
